import script from "./whCOnceImg2.vue?vue&type=script&setup=true&lang=js"
export * from "./whCOnceImg2.vue?vue&type=script&setup=true&lang=js"

import "./whCOnceImg2.vue?vue&type=style&index=0&id=00618eac&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00618eac"]])

export default __exports__